import { useQuery } from 'react-query';

import { KimThread } from '../../../../backend/src/matter/subset/thread/kim-thread.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

interface UseGetKimThreadOptions {
  refetchInterval?: number | false;
}

export const useGetKimThread = (
  matterId?: string,
  subsetId?: string,
  threadId?: string,
  options?: UseGetKimThreadOptions,
) => {
  const fetcher = useFetcher();

  return useQuery<KimThread, ApiError>(
    [QueryEntity.KimThread, { threadId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}`),
    {
      enabled: !!matterId && !!subsetId && !!threadId,
      refetchOnWindowFocus: false,
      refetchInterval: options?.refetchInterval ?? false,
      retry: (failureCount, error) => error.code !== 404 && failureCount < 3,
    },
  );
};
